<mat-dialog-content [ngClass]="{ noscroll: noscroll }">
    <div class="clare-controller-input" [ngClass]="{ addNewPanel: isAddPanel }">
        <h1 *ngIf="!isInsideWizard">Enter Controller UUID</h1>
        <div class="scanner" [hidden]="qrcodeDetected">
            <p *ngIf="isInsideWizard || !isAddPanel" class="scanner-text" [ngClass]="{ 'small-help-text': isInsideWizard }">
                Scan the QR code from the bottom of your Clare controller or its box using this device's camera. If this device doesn't have
                a camera, manually enter the UUID below without special characters.<br />
            </p>
            <a
                class="scanner-button"
                mat-stroked-button
                (click)="rescanCode()"
                *ngIf="videoDisabled"
                fxLayout="row"
                fxLayoutAlign="center center"
                >Tap to scan a Clare QR code</a
            >
            <canvas class="video" #controllerIdEl id="scan-canvas" width="300" [hidden]="videoDisabled"></canvas>
        </div>
        <form [formGroup]="cliqAddressInput">
            <p class="uuid-input-field">
                <mat-form-field appearance="outline" *letVar="fields.controllerId as field">
                    <mat-label #uuidLabel>{{ controllerLabel }}</mat-label>
                    <input
                        matInput
                        #uuidInput
                        id="controllerId"
                        type="text"
                        placeholder="Enter a {{ controllerLabel }}"
                        formControlName="controllerId"
                        (focusout)="correctUuid()"
                        required
                    />
                    <mat-error>
                        <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                    </mat-error>
                </mat-form-field>
                <span class="test-message" *ngIf="raLinkConnectionValid === null && fields.controllerId.value !== null">
                    <span class="success" *ngIf="(isValidUuid && !projectExists) || isExistingProjectThisProject"
                        >The UUID is valid. Test the connection.</span
                    >
                    <span class="error" *ngIf="projectExists && !isExistingProjectThisProject"
                        >An account already exists for this controller.
                    </span>
                    <span *ngIf="!isValidUuid">
                        <a *ngIf="!validateForMini" (click)="switchValidateForMini(true)">Try the new UUID format</a>
                    </span>
                </span>
                <span
                    *ngIf="raLinkConnectionValid !== null"
                    class="test-message"
                    [ngClass]="{
                        error: !raLinkConnectionValid,
                        success: raLinkConnectionValid
                    }"
                >
                    The controller is
                    <span *ngIf="raLinkConnectionValid">online</span><span *ngIf="!raLinkConnectionValid">offline</span></span
                >
                <button
                    mat-stroked-button
                    *ngIf="(isValidUuid && !projectExists) || isExistingProjectThisProject"
                    (click)="testRaLinkConnection()"
                    type="button"
                >
                    Test Connection
                </button>
                &nbsp;
                <button type="button" mat-stroked-button *ngIf="qrcodeDetected" (click)="rescanCode()">Rescan Code</button>
            </p>
            <div class="serial-number-input-field" *ngIf="requiresVerification && raLinkConnectionValid !== null">
                <h3>Controller Verification</h3>
                <p>
                    This controller is in use and requires you to verify its serial number.
                    <br />Serial numbers can only be verified with an online controller.
                </p>
            </div>
            <div fxLayout="row wrap" class="serial-number-block" *letVar="fields.serialNumber as field">
                <mat-form-field appearance="outline" fxFlex="1 1 100%">
                    <mat-label #serialLabel>{{ serialNumberLabel }}</mat-label>
                    <input
                        matInput
                        id="serialNumber"
                        type="text"
                        uppercase-inp
                        placeholder="Enter a {{ serialNumberLabel }}"
                        formControlName="serialNumber"
                        [required]="isClareOne"
                    />
                    <mat-error>
                        <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                    </mat-error>
                </mat-form-field>
                <ng-container *ngIf="!isClareOne && !isAddPanel">
                    <mat-form-field appearance="outline" fxFlex="1 1 100%" *letVar="fields.securityMacAddress as field">
                        <mat-label #serialLabel>Security MAC Address</mat-label>
                        <input
                            matInput
                            id="securityMacAddress"
                            type="text"
                            uppercase-inp
                            placeholder="Enter Security System MAC address"
                            formControlName="securityMacAddress"
                        />
                        <mat-error>
                            <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                        </mat-error>
                    </mat-form-field>
                </ng-container>

                <mat-form-field appearance="outline" fxFlex="1 1 100%" *letVar="fields.iccid as field">
                    <mat-label #serialLabel>ICCID</mat-label>
                    <input matInput id="iccid" type="text" placeholder="Enter an ICCID" formControlName="iccid" />
                    <mat-error>
                        <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                    </mat-error>
                </mat-form-field>
            </div>
            <p *ngIf="raLinkConnectionValid !== null">
                <span class="test-message error" *ngIf="fields.serialNumber.value !== null && !isValidSerialNumber">
                    The serial number is invalid.
                </span>
                <span
                    class="test-message error"
                    *ngIf="
                        !isPendingVerification &&
                        !isControllerVerified &&
                        requiresVerification &&
                        !isIncorrectSerialNumber &&
                        isControllerOnline
                    "
                    >The controller is unverified.</span
                >
                <span
                    class="test-message error"
                    *ngIf="
                        !isPendingVerification &&
                        !isControllerVerified &&
                        requiresVerification &&
                        !isIncorrectSerialNumber &&
                        !isControllerOnline
                    "
                >
                    The controller is offline. Unable to verify.
                </span>

                <span
                    class="test-message error"
                    *ngIf="!isPendingVerification && !isControllerVerified && requiresVerification && isIncorrectSerialNumber"
                >
                    Verification failed. Incorrect {{ verificationFieldName }}.
                </span>

                <span class="test-message success" *ngIf="!isPendingVerification && isControllerVerified && requiresVerification">
                    The controller is verified.
                </span>

                <span class="test-message" *ngIf="isPendingVerification">Verifying controller...</span>

                <button
                    mat-button
                    mat-stroked-button
                    *ngIf="!isControllerVerified && requiresVerification"
                    [disabled]="!fields.serialNumber.valid && raLinkConnectionValid"
                    (click)="verifyController()"
                    type="button"
                >
                    Verify Controller
                </button>
            </p>
            <clare-spinner *ngIf="checkingService.loading" text="Checking services active status..."></clare-spinner>
            <p *ngIf="servicesChecker?.type">
                <app-clare-alert [messageType]="servicesChecker.type" [message]="servicesChecker.message"></app-clare-alert>
            </p>
            <button
                mat-raised-button
                [disabled]="notAbleToSaveController"
                (click)="submitForm()"
                class="new-primary-button"
                color="primary"
                [ngClass]="{ 'full-width': isInsideWizard }"
            >
                {{ saveButtonLabel }}
            </button>
        </form>
    </div>
</mat-dialog-content>
